import React from "react";
import { Empty, Form } from "antd";
import { FormInstance } from "antd/lib/form/Form";
import { EnumRole } from "@src/types/role";
import { useAllProducts } from "@src/hooks/use-all-products";
import { useMe } from "@src/hooks/use-me";
import { IntelligenceFormFieldsEnum } from "../enum";
import { DEFAULT_TITLE } from "../create";
import { SelectWithSpinAndCustomMaxTag } from "@src/components/select/SelectWithCustomMaxTag";
import { PERMISSION_FORCED_DISABLED_CLASS } from "@src/components/crud-permission-layout";

export const ProductInput: React.FC<{ form: FormInstance<any>; isCreate?: boolean }> = ({ form, isCreate = false }) => {
    const { roles, isSuperAdmin } = useMe();

    const productCodesFiltered = roles.map((r: any) => r.productCode);
    const { products, isLoading } = useAllProducts({
        filters: !isSuperAdmin
            ? [
                  {
                      field: "code",
                      operator: "in",
                      value: productCodesFiltered,
                  },
              ]
            : [],
        enabled: productCodesFiltered.length > 0,
    });
    const renderLabelProduct = (product: any) => {
        return (
            <div className="flex items-center">
                <img src={product.icon} className="w-4 h-4 rounded-[2px] mr-2" />
                {product.name} - {product.productCode}
            </div>
        );
    };

    const options = React.useMemo(() => {
        return products.map((product) => {
            const role = roles.find((r: { productCode: string }) => r.productCode === product.code);
            const disabled = !isSuperAdmin && role.role === EnumRole.ProductViewer;
            return {
                label: renderLabelProduct(product),
                value: product.code,
                title: product.name,
                disabled,
            };
        });
    }, [products]);

    return (
        <Form.Item
            className={`pb-2 ${PERMISSION_FORCED_DISABLED_CLASS}`}
            label={""}
            name={IntelligenceFormFieldsEnum.PRODUCT_CODE}
            required
            rules={[{ required: true, message: "Please select product" }]}
        >
            <SelectWithSpinAndCustomMaxTag
                options={options}
                loading={isLoading}
                placeholder="Select product"
                showSearch
                filterOption={(input, option) => {
                    const { title, value } = option as any;
                    if (!value || !title) return false;
                    return (
                        title.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0 ||
                        value.toString().toLowerCase().indexOf(input.toLowerCase()) >= 0
                    );
                }}
                onChange={(value) => {
                    const symbols = ["i", "a"];
                    let formValue: Record<string, any> = {
                        [IntelligenceFormFieldsEnum.PLATFORM]: symbols.map((s) => value + s),
                    };
                    if (isCreate && !form.getFieldValue(IntelligenceFormFieldsEnum.IS_CUSTOM_TITLE)) {
                        formValue = {
                            ...formValue,
                            [IntelligenceFormFieldsEnum.TITLE]: DEFAULT_TITLE + " - " + value,
                        };
                    }
                    form.setFieldsValue(formValue);
                }}
                allowClear
                style={{ width: 300 }}
                notFoundContent={
                    <Empty className="text-[12px]" description="You are not in product! Please contact your admin" />
                }
            />
        </Form.Item>
    );
};
